import { IconType } from 'components/Icon';
import { DesignSystemSection } from './types';

export const DS_TAB_CHROME: Record<
	DesignSystemSection,
	{
		icon: IconType;
		label: string;
	}
> = {
	foundations: { icon: IconType.STACK_LINE, label: 'Foundations' },
	guidelines: { icon: IconType.BOOK_OPEN, label: 'Guidelines' },
	theme: { icon: IconType.PALETTE, label: 'Theme' },
	styles: { icon: IconType.CONTRAST_DROP, label: 'Styles' },
	components: { icon: IconType.PUZZLE2, label: 'Components' },
	gallery: { icon: IconType.LAYOUT, label: 'Gallery' },
	assets: { icon: IconType.ATTACHMENT_2, label: 'Assets' },
};
